import React, { useEffect, useState } from 'react'
import { Button, Card, Table } from "antd";
import { getProductionProcessWithPage } from "../../services/serviceProductionProcess";
import ProductionProcessCreate from "./ProductionProcessCreate";
import ProductionProcessActions from "./ProductionProcessActions";


const ProductionProcess = () => {
    const [newModal, setNewModal] = useState(false);
    const [sortedList, setSortedList] = useState([]);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });

    useEffect(() => {
        getProductionProcess(pagination.current, pagination.pageSize);
    }, [pagination.current, pagination.pageSize])

    const getProductionProcess = (page, pageSize) => {
        getProductionProcessWithPage(page - 1, pageSize)
            .then(({ data }) => {
                handlers.sortData(data.content);
                setPagination({
                    ...pagination,
                    total: data.totalElements,
                })
            })
    };

    const handlePaginationChange = (pageNumber, pageSize) => {
        setPagination({
            ...pagination,
            current: pageNumber,
            pageSize: pageSize
        });
    };

    const handlers = {
        updater() {
            getProductionProcess(1, 10);
        },
        modalCloser() {
            setNewModal(!newModal)
        },
        sortData(list) {
            let sorted = []
            list.forEach((item) => {
                let pushObj = {
                    key: item.id,
                    id: item.id,
                    productionNumber: item.production.productionNumber,
                    productionQuantity: item.quantity,
                    productionStatus: item.productionStatus === 'SUCCESS' ? 'Başarılı' : 'Hatalı',
                    productionRecipe: item.production.recipe.name
                }
                sorted.push(pushObj)
            })
            setSortedList(sorted)
        }
    }

    const columns = [
        {
            title: 'Üretim Numarası',
            dataIndex: 'productionNumber'
        },
        {
            title: 'Reçete',
            dataIndex: 'productionRecipe',
            key: 'productionRecipe'
        },
        {
            title: 'Miktar',
            dataIndex: 'productionQuantity'
        },
        {
            title: 'Durum',
            dataIndex: 'productionStatus'
        },
        {
            title: 'İşlemler',
            key: 'actions',
            render: (text, record) => <ProductionProcessActions record={record} updater={handlers.updater} />
        }
    ]

    return (
        <React.Fragment>
            <Card
                title={'Üretim Giriş'}
                extra={
                    <Button
                        onClick={() => setNewModal(!newModal)}
                        type={'primary'}

                    >
                        Yeni Ekle
                    </Button>
                }
            >
                <Table
                    scroll={{ x: 'max-content' }}
                    dataSource={sortedList}
                    columns={columns}
                    pagination={{
                        ...pagination,
                        showSizeChanger: true,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        onChange: handlePaginationChange,
                    }}
                />
            </Card>

            {newModal ? <ProductionProcessCreate show={newModal} modalCloser={handlers.modalCloser}
                updater={handlers.updater} /> : null}
        </React.Fragment>
    )
}
export default ProductionProcess